import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
// import { True32 } from '../../../../public/LoginImages/importimages'
import { apiurl } from "../../../../../path";
import { Link } from "react-router-dom";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import "../grdraftreceipt.css";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import GooglePagination from '../../../styles/GooglePagination';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { formatIndianAmount  } from '../../../../../utils/DateFormat';

const GRApprovals = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const [selectedGR, setSelectedGR] = useState(null);

  const { GetGRPendingListForApprove, ApproveGR, CreateToken, Usermenu ,GetWorksByGR, GetMyDepartmentAccess } =
    context; // Ensure ApproveBills is defined in your context
  const [bills, setBills] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10; // Show 10 bills per page
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedZillaParishad, setSelectedZillaParishad] = useState("");

  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");

  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);
  const [adminData, setAdminData] = useState([]);
   const [selectedHeadCode, setSelectedHeadCode] = useState("");
const [grId, setgrID] = useState("");
  const [worksData, setWorksData] = useState([]);
    const [grNumber, setgrNumber] = useState("");
      const [showWorksView, setShowWorksView] = useState(false);
  const totalPages = Math.ceil(
    filteredBills
      ? filteredBills.length / billsPerPage
      : bills.length / billsPerPage,
  );
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const sortedBills1 = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
  .sort((a, b) => new Date(b.Date) - new Date(a.Date))
          : [];
  const sortedBills = sortedBills1;
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = filteredBills ? filteredBills.slice(indexOfFirstBill, indexOfLastBill) : bills.slice(indexOfFirstBill, indexOfLastBill);
  const headerStyle = {
    padding: "12px 22px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

// //////Adddddd
    const parseIds = (v) => {
    try {
      const p = typeof v === "string" ? JSON.parse(v) : v;
      return (Array.isArray(p) ? p : [p]).map(Number).filter(Boolean);
    } catch {
      return [];
    }
  };
    const [myDepartments, setMyDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    useEffect(() => {
      (async () => {
        try {
          const r = await GetMyDepartmentAccess();
          setMyDepartments(r?.data?.departments || []);
        } catch (e) {
          console.error("GetMyDepartmentAccess failed", e);
        }
      })();
    }, []);


  const GetAdminData = async () => {
    try {
      let data = await Usermenu();
      console.log("data ------------", data);

      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return [];
      }

      const userData = data.Data; // ← Access Data object
      const menuList = data.result || []; // ← Access menu list

      setAdminData(userData);

      console.log("User Data:", userData);
      console.log("Menus:", menuList);
    } catch (err) {
      console.error("Error in GetAdminData:", err);
    }
  };
  useEffect(() => {
    GetAdminData();
  }, []);
  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken("GR Approval");
    document.getElementById("tokencopys").innerText = data;
    SetEtoken(data);
    sethide(false);
  }

  // Filter logic
  // const filteredBills = filter ? bills.filter((bill) => bill.TypeOfAmount === filter) : bills;
  const getbills = async () => {
    let data = await GetGRPendingListForApprove();
    console.log("datagr", data);

    setBills(data);
    setFilteredBills(data);
  };

  useEffect(() => {
    getbills();
  }, []);

  // Handle individual checkbox selection
  const handleCheckboxChange = (id) => {
    setSelectedBills(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((billId) => billId !== id) // Remove if already selected
          : [...prevSelected, id], // Add if not selected
    );
  };

  // Handle "Select All" checkbox
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.GRID));
    } else {
      setSelectedBills([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No GR selected !!!");
      return;
    }
    console.log(selectedBills);
    if (condition == "Rejected" || condition == "SendBack") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      // ❌ If remark is empty after trimming
      if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
      }
    }
    setLoading(true); // Start loader
    let shouldStart = window.confirm("Are you sure ??");

    if (shouldStart) {
      try {
        let response = await ApproveGR(
          selectedBills,
          condition,
          remark,
          Etoken,
        ); // Call backend function
        if (response.message) {
          alert(response.message);
          window.location.reload();
          setRemark("");
          setRejectpanelhide(0);
          getbills(); // Refresh the list after approval
        }
        if (response.error) {
          alert(response.error);
          window.location.reload();
          getbills(); // Refresh the list after approval
        }
      } catch (error) {
        console.error("Error Approving or Rejecting  bills:", error);
        alert("An error occurred while approving or rejecting bills.");
      }
    } else {
      alert(`Gr ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      window.location.reload();
      getbills();
    }
    setLoading(false); // Stop loader
  };


 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = bills.filter((bill) => {
 
        const matchesSearch = Object.values(bill).some((value) =>
            (value || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesHeadCode =
            selectedHeadCode === "" ||
            bill.HeadCode?.startsWith(selectedHeadCode);
 
        const matchesZillaParishad =
            selectedZillaParishad === "" ||
            bill.ZillaParishad === selectedZillaParishad;
 
                    /////Addddddd
         const matchesDepartment =
        selectedDepartment === "" ||
        parseIds(bill.DepartmentAccessID).includes(Number(selectedDepartment));

        return (
            matchesSearch &&
            matchesHeadCode &&
            matchesZillaParishad && matchesDepartment
        );
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
 
}, [searchTerm, selectedHeadCode, selectedZillaParishad, selectedDepartment, bills]);
 

    // ///////////////////////////
const downloadGRApprovalPDF = async (
    filename = "GR_Approval_Report",
    title = "GR Approval Report"
) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
        alert("No data available");
        return;
    }

    setLoading(true);

    let tempContainer;

    try {
        const pdf = new jsPDF("l", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const margin = 8;
        const titleY = 10;
        const tableY = 17;
        const footerY = pageHeight - 5;

        const availableWidth = pageWidth - margin * 2;
        const availableHeight = footerY - tableY - 5;

        // Match the columns in your React table.
        const headers = [
            "Sr.No",
            "GR Number",
            "GR Amount",
            ...(adminData.Role === "RDD Section Officer"
                ? []
                : ["Head Code"]),
            "Year",
            "Zilla Parishad",
            "GR UID",
            "Creation Date",
            "GR Copy",
            "GR Approval Copy"
        ];

        tempContainer = document.createElement("div");

        Object.assign(tempContainer.style, {
            position: "absolute",
            left: "-99999px",
            top: "0",
            width: "1400px",
            padding: "0",
            margin: "0",
            backgroundColor: "#ffffff",
            boxSizing: "border-box"
        });

        document.body.appendChild(tempContainer);

        // Create a table row using the same formatting throughout.
        const createCell = (value, isHeader = false) => {
            const cell = document.createElement(isHeader ? "th" : "td");

            cell.innerText = String(value ?? "-");

            Object.assign(cell.style, {
                border: "1px solid #999",
                padding: isHeader ? "8px" : "10px 8px",
                textAlign: "center",
                verticalAlign: "middle",
                fontFamily: "Arial, sans-serif",
                fontSize: isHeader ? "12px" : "11px",
                fontWeight: isHeader ? "bold" : "500",
                whiteSpace: "pre-line",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
                boxSizing: "border-box"
            });

            if (isHeader) {
                cell.style.backgroundColor = "#1976d2";
                cell.style.color = "#ffffff";
            }

            return cell;
        };

        // Add rows dynamically according to the available page height.
        let start = 0;
        let pageNumber = 1;
        const pageRanges = [];

        while (start < filteredBills.length) {
            tempContainer.innerHTML = "";

            const table = document.createElement("table");

            Object.assign(table.style, {
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                fontFamily: "Arial, sans-serif",
                backgroundColor: "#ffffff"
            });

            const thead = document.createElement("thead");
            const headerRow = document.createElement("tr");

            headers.forEach((header) => {
                headerRow.appendChild(createCell(header, true));
            });

            thead.appendChild(headerRow);
            table.appendChild(thead);

            const tbody = document.createElement("tbody");
            table.appendChild(tbody);
            tempContainer.appendChild(table);

            let nextIndex = start;

            while (nextIndex < filteredBills.length) {
                const bill = filteredBills[nextIndex];

                // Match the conditional Head Code column in the UI.
                const rowData = [
                    nextIndex + 1,
                    bill.GRNumber || "-",
                    bill.GRAmount ?? "-",
                    ...(adminData.Role === "RDD Section Officer"
                        ? []
                        : [bill.HeadCode || "-"]),
                    bill.ProposalYear || "-",
                    bill.ZillaParishad || "-",
                    bill.GRID || "-",
                    bill.Date
                        ? new Date(bill.Date).toLocaleString("en-IN")
                        : "-",
                    [
                        bill.GRUploadFile,
                        bill.GRCopy
                    ].filter(Boolean).join("\n") || "No File",
                    bill.GRDraftCopy || "No File"
                ];

                const row = document.createElement("tr");

                row.style.backgroundColor =
                    nextIndex % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                rowData.forEach((value) => {
                    const cell = createCell(value);
                    cell.style.backgroundColor = row.style.backgroundColor;
                    row.appendChild(cell);
                });

                tbody.appendChild(row);

                // scrollHeight measures the actual table height,
                // including wrapped filenames and long text.
                const renderedHeight = tempContainer.scrollHeight;
                const renderedWidth = tempContainer.scrollWidth;

                const estimatedPdfHeight =
                    (renderedHeight * availableWidth) / renderedWidth;

                if (estimatedPdfHeight > availableHeight) {
                    tbody.removeChild(row);
                    break;
                }

                nextIndex++;
            }

            // Avoid getting stuck if a single row is unusually tall.
            if (nextIndex === start) {
                const bill = filteredBills[start];

                const rowData = [
                    start + 1,
                    bill.GRNumber || "-",
                    bill.GRAmount ?? "-",
                    ...(adminData.Role === "RDD Section Officer"
                        ? []
                        : [bill.HeadCode || "-"]),
                    bill.ProposalYear || "-",
                    bill.ZillaParishad || "-",
                    bill.GRID || "-",
                    bill.Date
                        ? new Date(bill.Date).toLocaleString("en-IN")
                        : "-",
                    [
                        bill.GRUploadFile,
                        bill.GRCopy
                    ].filter(Boolean).join("\n") || "No File",
                    bill.GRDraftCopy || "No File"
                ];

                const row = document.createElement("tr");

                row.style.backgroundColor =
                    start % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                rowData.forEach((value) => {
                    const cell = createCell(value);
                    cell.style.backgroundColor = row.style.backgroundColor;
                    row.appendChild(cell);
                });

                tbody.appendChild(row);
                nextIndex = start + 1;
            }

            const canvas = await html2canvas(tempContainer, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#ffffff",
                logging: false
            });

            if (pageNumber > 1) {
                pdf.addPage();
            }

            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(15);

            pdf.text(title, pageWidth / 2, titleY, {
                align: "center"
            });

            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);

            pdf.text(
                `Records ${start + 1} - ${nextIndex} of ${filteredBills.length}`,
                pageWidth - margin,
                titleY,
                { align: "right" }
            );

            const imgWidth = availableWidth;
            const imgHeight =
                (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(
                canvas.toDataURL("image/png"),
                "PNG",
                margin,
                tableY,
                imgWidth,
                imgHeight
            );

            pageRanges.push({
                start: start + 1,
                end: nextIndex
            });

            start = nextIndex;
            pageNumber++;
        }

        // Add accurate page numbers after all pages are generated.
        const totalPages = pdf.getNumberOfPages();

        for (let page = 1; page <= totalPages; page++) {
            pdf.setPage(page);
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);

            pdf.text(
                `Page ${page} / ${totalPages}`,
                pageWidth / 2,
                footerY,
                { align: "center" }
            );
        }

        pdf.save(`${filename}.pdf`);
    } catch (error) {
        console.error("GR Approval PDF Export Error:", error);
        alert("Error while generating PDF");
    } finally {
        if (tempContainer?.parentNode) {
            tempContainer.parentNode.removeChild(tempContainer);
        }

        setLoading(false);
    }
};

    const exportGRToExcel = async (
        filteredBills,
        filename = "GR_Approval_Report.xlsx"
    ) => {
        if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
            alert("No data available");
            return;
        }

        setLoading(true);

        try {
            let totalAmount = 0;

            const excelData = filteredBills.map((bill, index) => {
                const amount = Number(bill.GRAmount || 0);
                totalAmount += amount;

                return {
                    "Sr.No": index + 1,
                    "GR Number": bill.GRNumber || "-",
                    // "Head Code": bill.HeadCode || "-",
                    "Year": bill.ProposalYear || "-",
                    "Zilla Parishad": bill.ZillaParishad || "-",
                    "GR UID": bill.GRID || "-",
                   "Creation Date": bill.Date
                        ? new Date(bill.Date).toLocaleString()
                        : "-",

                    // "Uploaded By": bill.Uploadedby || "--",

                    // "RDD Section Officer":
                    //     bill.Approve2 === "true"
                    //         ? "Approved"
                    //         : bill.Approve2 === "false"
                    //             ? "Rejected"
                    //             : "Pending",

                    // "Deputy / Joint Secretary":
                    //     bill.Approve3 === "true"
                    //         ? "Approved"
                    //         : bill.Approve3 === "false"
                    //             ? "Rejected"
                    //             : "Pending",
                };
            });

            excelData.push({
                "Sr.No": "",
                "GR Number": "",
                // "Head Code": "",
                "Year": "",
                "Zilla Parishad": "",
                "GR UID": "",
                "Creation Date": "",
                // "Uploaded By": "",
                // "RDD Section Officer": "",
                // "Deputy / Joint Secretary": "",
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            worksheet["!cols"] = [
                { wch: 8 },
                { wch: 20 },
                { wch: 20 },
                { wch: 25 },
                { wch: 12 },
                { wch: 25 },
                { wch: 22 },
                { wch: 20 },
                { wch: 20 },
                { wch: 25 },
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "GR Approval");

            XLSX.writeFile(workbook, filename);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    // ///////////////////////////



  //--> old code
//   useEffect(() => {
//     const lowerSearchTerm = searchTerm.toLowerCase();
 
//     const filtered = bills.filter((bill) => {
//         const matchesSearch = Object.values(bill).some((value) =>
//             (value || "").toString().toLowerCase().includes(lowerSearchTerm)
//         );
 
//         const matchesHeadCode =
//             selectedHeadCode === "" ||
//             bill.HeadCode?.startsWith(selectedHeadCode);
 
//         return matchesSearch && matchesHeadCode;
//     });
 
//     setFilteredBills(filtered);
//     setCurrentPage(1);
// }, [searchTerm, selectedHeadCode, bills]);
const fetchWorksByGR = async (grid) => {
    setLoading(true);
    try {
      let data = await GetWorksByGR(grid);
      if (data.status) {
        setWorksData(data.message);
      }
    } catch (error) {
      console.error("Error fetching works:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {
        showWorksView==false&& (
<>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-11 m-auto">
          <div className="col-12 ">
            <div
              className="col-12 px-4 mb-4 mt-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="my-auto fw-bold">
                <img
                  src="/GR-Approval64.png"
                  alt="Gr Approval"
                  style={{ width: "24px", height: "24px" }}
                  className="my-auto me-1"
                />
                <span className="my-auto">{t("GR Approvals")}</span>
              </h5>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
 
 
                             {/* HeadCode Filter */}
                             {/* <select
                                 value={selectedHeadCode}
                                 onChange={(e) => setSelectedHeadCode(e.target.value)}
                                 style={{
                                     width: "340px",
                                     padding: "8px 10px",
                                     border: "1px solid #ccc",
                                     borderRadius: "8px",
                                     backgroundColor: "#f1f6fc",
                                     fontSize: "14px",
                                     outline: "none"
                                 }}
                             >
                                 <option value="">{t("All Head Codes")}</option>
                                 <option value="3054">
                                     3054-2419 (Roads and Bridge Repair Maintenance Program)
                                 </option>
                                 <option value="2515">
                                     2515-1238 (MLA Representative)
                                 </option>
                             </select> */}

                             {/* Zilla Parishad Filter */}
                             <select
                                 value={selectedZillaParishad}
                                 onChange={(e) => setSelectedZillaParishad(e.target.value)}
                                 style={{
                                     width: "220px",
                                     padding: "8px 10px",
                                     border: "1px solid #ccc",
                                     borderRadius: "8px",
                                     backgroundColor: "#f1f6fc",
                                     fontSize: "14px",
                                     outline: "none"
                                 }}
                             >
                                 <option value="">All Zilla Parishad</option>
 
                                 {[...new Set(
                                     bills
                                         ?.map((bill) => bill.ZillaParishad)
                                         .filter(Boolean)
                                 )]
                                     .sort()
                                     .map((zillaParishad, index) => (
                                         <option key={index} value={zillaParishad}>
                                             {zillaParishad}
                                         </option>
                                     ))}
                             </select>

  {myDepartments.length > 1 && (
  <select
    value={selectedDepartment}
    onChange={(e) => setSelectedDepartment(e.target.value)}
    style={{
      width: "220px",
      padding: "8px 10px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      backgroundColor: "#f1f6fc",
      fontSize: "14px",
      outline: "none",
    }}
  >
    <option value="">{t("Select Department")}</option>
    {myDepartments.map((d) => (
      <option key={d.id} value={d.id}>
        {d.name}
      </option>
    ))}
  </select>
)}


 
                             {/* Search */}
                             <div style={{ position: "relative", width: "250px" }}>
                                 <img
                                     src="/Search32.png"
                                     alt="Search Icon"
                                     style={{
                                         position: "absolute",
                                         top: "50%",
                                         left: "10px",
                                         transform: "translateY(-50%)",
                                         width: "16px",
                                         height: "16px",
                                         opacity: 0.6
                                     }}
                                 />
 
                                 <input
                                     type="text"
                                     placeholder={t("Search Here")}
                                     onChange={(e) => setSearchTerm(e.target.value)}
                                     value={searchTerm}
                                     style={{
                                         width: "100%",
                                         padding: "8px 12px 8px 32px",
                                         border: "1px solid #ccc",
                                         borderRadius: "8px",
                                         backgroundColor: "#f1f6fc",
                                         fontSize: "14px",
                                         color: "#333",
                                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                         outline: "none"
                                     }}
                                 />
                             </div>
                         </div>
              {/* <input
                            type="text"
                            placeholder="Search"
                            onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }}
                        /> */}
            </div>


                                    {/* /////////// */}
                        <div className='mb-3 me-2'
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "10px"
                            }}
                        >

                          <button
                                className="btn btn-success"
                                onClick={() =>
                                    exportGRToExcel(
                                        filteredBills,
                                        "GR_Approval_Report.xlsx"
                                    )
                                }
                            >
                                {t("Download Excel")}
                            </button>

                            <button
                                className="btn btn-danger"
                                disabled={loading}
                                onClick={() =>
                                    downloadGRApprovalPDF(
                                        "GR_Approval_Report",
                                        "GR Approval Report"
                                    )
                                }
                            >
                                {loading ? t("Downloading...") : t("Download PDF")}
                            </button>

                            

                        </div>
                        {/* /////////// */}


             <div className="col-12 pb-5">
                         <div
                           className="m-auto mb-3"
                           style={{
                             backgroundColor: "white",
                             padding: "40px 40px",
                             boxShadow: "0px 0px 5px 1px #E4E8EC",
                             borderRadius: "20px",
                             width: "100%",
                             maxWidth: "100%",
                             overflowX: "hidden",
                           }}
                         >
                           <div
                             className="col-12 tableDesign"
                             style={{
                               background: "#2C78DB",
                               overflowY: "hidden",
                               overflowX: "auto",
                                 overflowY: "auto",
                                 maxHeight: "600px", // change height as needed
                                 position: "relative",
                             }}
                           >
                             <table
                               className="m-0 p-0"
                               style={{
                                 width: "100%",
                                 borderCollapse: "collapse",
                                 fontSize: "18px",
                               }}
                             >
                               <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                                 top: 0,
                                 zIndex: 10,}}>
                                 <tr
                                   style={{
                                     color: "white",
                                     border: "none",
                                     height: "3rem",
                                     fontSize: "18px",
                                     minHeight: "3rem",
                                     fontWeight: "400",
                                   }}
                                 >
                                   <th style={{ minWidth: "70px", padding: "8px" }}>
                                     <input
                                       type="checkbox"
                                       onChange={handleSelectAll}
                                       checked={
                                         selectedBills.length === currentBills.length
                                       }
                                       className="my-auto"
                                       style={{ height: "1rem", width: "1rem" }}
                                     />
                                   </th>
                                   <th style={{ minWidth: "65px", padding: "8px" }}>
                                     {t("Sr.No")}
                                   </th>
                                   <th style={{ minWidth: "100px", padding: "8px" }}>
                                     {t("GR Number")}
                                   </th>
                                   
             <th style={{ minWidth: "100px", padding: "8px" }}>{t("GR Amount")}</th>
                                   {adminData.Role == "RDD Section Officer" ? (
                                     ""
                                   ) : (
                                     <th style={{ minWidth: "220px", padding: "8px" }}>
                                       {t("Head Code")}
                                     </th>
                                   )}
                                   <th style={{ minWidth: "100px", padding: "8px" }}>
                                     {t("Year")}
                                   </th>
                                   <th style={{ minWidth: "150px", padding: "8px" }}>
                                     {t("Zilla Parishad")}
                                   </th>
                                   <th style={{ minWidth: "130px", padding: "8px" }}>
                                     {t("GR UID")}
                                   </th>
                                    <th style={{ minWidth: "120px", padding: "10px" }}>{t("GR Date")}</th>
                                   <th style={{ minWidth: "120px", padding: "10px" }}>
                                     {t("Creation Date")}
                                   </th>
                                  <th style={{ minWidth: "190px", padding: "8px" }}>{t("GR copy")}</th>
                                   <th style={{ minWidth: "190px", padding: "8px" }}>
                                     {t("GR Approval Copy")}
                                   </th>
                                 </tr>
                               </thead>
                               <tbody>
                                 {currentBills.length <= 0 ? (
                                   <tr>
                                     <td
                                       colSpan="30"
                                       style={{
                                         textAlign: "center",
                                         padding: "20px 10px",
                                         backgroundColor: "#f9f9f9",
                                       }}
                                     >
                                       {t("No data available")}
                                     </td>
                                   </tr>
                                 ) : (
                                   currentBills.map((bill, index) => {
                                     const bgColor =
                                       index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                     return (
                                       <tr
                                         style={{
                                           backgroundColor: bgColor,
                                           fontSize: "18px",
                                           fontWeight: "500",
                                         }}
                                         key={index}
                                       >
                                         <td
                                           style={{
                                             textAlign: "center",
                                             padding: "10px 8px",
                                           }}
                                         >
                                           <input
                                             type="checkbox"
                                             className="my-auto"
                                             style={{ height: "1rem", width: "1rem" }}
                                             checked={selectedBills.includes(bill.GRID)}
                                             onChange={() =>
                                               handleCheckboxChange(bill.GRID)
                                             }
                                           />
                                         </td>
                                         <td style={{ padding: "10px 8px" }}>
                                           {indexOfFirstBill + index + 1}
                                         </td>
                                         <td style={{ padding: "8px 8px" }}>
                                           {bill.GRNumber}
                                         </td>
                                         <td style={{ textAlign: "center", padding: '10px 8px' }}>
                                           <span
                                             style={{
                                               color: "#0d6efd",
                                               textDecoration: "underline",
                                               cursor: "pointer",
                                               fontWeight: "500",
                                             }}
                                             onClick={() => {
                                               setgrID(bill.GRID);
                                               setgrNumber(bill.GRNumber);
                                               setShowWorksView(true);
                                               fetchWorksByGR(bill.GRNumber);
                                             }}
                                           >
                                             {formatIndianAmount(bill.GRAmount)}
                                           </span>
                                         </td>
                                         {adminData.Role == "RDD Section Officer" ? (
                                           ""
                                         ) : (
                                           <td style={{ padding: "10px 8px" }}>
                                             {bill.HeadCode}
                                           </td>
                                         )}
                                         <td style={{ padding: "8px 8px" }}>
                                           {bill.ProposalYear}
                                         </td>
                                         <td style={{ padding: "8px 8px" }}>
                                           {bill.ZillaParishad}
                                         </td>
                                         <td style={{ padding: "8px 8px" }}>
                                           {bill.GRID}
                                         </td>
                                         <td className='px-2'>

                                           <span>{new Date(bill.GRDate).toLocaleDateString("en-IN")}</span>

                                         </td>
                                         <td className="px-2">
                                           <div
                                             style={{
                                               display: "flex",
                                               alignItems: "center",
                                               gap: "0.2rem",
                                             }}
                                           >
                                             {/* <img
                                               src="/Time32.png"
                                               alt="time"
                                               style={{
                                                 width: "1.1rem",
                                                 height: "1.1rem",
                                               }}
                                             /> */}
                                             <span>
                                               {new Date(bill.Date).toLocaleDateString(
                                                 "en-IN",
                                               )}
                                             </span>
                                           </div>
                                         </td>
                                                                                                                                <td className="px-2 py-2">
             {bill.GRUploadFile || bill.GRCopy ? (
               <>
                 {bill.GRUploadFile && (
                   <div
                     style={{
                       display: "flex",
                       alignItems: "center",
                       gap: "0.4rem",
                       marginBottom: "4px"
                     }}
                   >
                     <img
                       src="/pdf-32.png"
                       alt="pdf"
                       style={{ width: "1.3rem", height: "1.3rem" }}
                     />
           
                     <a
                       href={`${apiurl}/ProposalFile/${bill.GRUploadFile}`}
                       target="_blank"
                       rel="noreferrer"
                       style={{ fontSize: "18px" }}
                       title={bill.GRUploadFile}
                     >
                       {bill.GRUploadFile}
                     </a>
                   </div>
                 )}
           
                 {bill.GRCopy && (
                   <div
                     style={{
                       display: "flex",
                       alignItems: "center",
                       gap: "0.4rem"
                     }}
                   >
                     <img
                       src="/pdf-32.png"
                       alt="pdf"
                       style={{ width: "1.3rem", height: "1.3rem" }}
                     />
           
                     <a
                       href={`${apiurl}/ProjectDocsImages/${bill.GRCopy}`}
                       target="_blank"
                       rel="noreferrer"
                       style={{ fontSize: "18px" }}
                       title={bill.GRCopy}
                     >
                       {bill.GRCopy}
                     </a>
                   </div>
                 )}
               </>
             ) : (
               <p className="fw-bold text-danger">
                 {t("No File")}
               </p>
             )}
           </td>
                                         <td className="px-2 py-2">
                                           {bill.GRDraftCopy ? (
                                             <div
                                               style={{
                                                 display: "flex",
                                                 alignItems: "center",
                                                 gap: "0.4rem",
                                               }}
                                             >
                                               <img
                                                 src="/pdf-32.png"
                                                 alt="pdf"
                                                 style={{
                                                   width: "1.3rem",
                                                   height: "1.3rem",
                                                 }}
                                               />
                                               <a
                                                 href={`${apiurl}/GRDraftCopy/${bill.GRDraftCopy}`}
                                                 target="_blank"
                                                 style={{ fontSize: "18px" }}
                                                 title={bill.GRDraftCopy}
                                               >
                                                 {bill.GRDraftCopy}
                                               </a>
                                             </div>
                                           ) : (
                                             <p className="fw-bold text-danger">
                                               {t("No File")}
                                             </p>
                                           )}
                                         </td>
                
                                         {/* <td
                                           className="px-2"
                                           style={{
                                             maxWidth: "140px",
                                             wordWrap: "break-word",
                                             whiteSpace: "normal",
                                           }}
                                         >
                                           {bill.GRDraftCopy ? (
                                             <div
                                               style={{
                                                 display: "flex",
                                                 alignItems: "center",
                                                 gap: "0.4rem",
                                               }}
                                             >
                                               <img
                                                 src="/pdf-32.png"
                                                 alt="pdf"
                                                 style={{
                                                   width: "1.3rem",
                                                   height: "1.3rem",
                                                 }}
                                               />
                                               <a
                                                 href={`${apiurl}/GRDraftCopy/${bill.GRDraftCopy}`}
                                                 target="_blank"
                                                 style={{
                                                   fontSize: "18px",
                                                   wordBreak: "break-word",
                                                 }}
                                                 title={bill.GRDraftCopy}
                                               >
                                                 {bill.GRDraftCopy}
                                               </a>
                                             </div>
                                           ) : (
                                             <p className="fw-bold text-danger">
                                               {t("No File")}
                                             </p>
                                           )}
                                         </td> */}
                                       </tr>
                                     );
                                   })
                                 )}
                               </tbody>
                             </table>
                           </div>
           
                           {selectedGR && (
                             <>
                               <div
                                 style={{
                                   position: "fixed",
                                   top: 0,
                                   left: 0,
                                   right: 0,
                                   bottom: 0,
                                   backgroundColor: "rgba(0, 0, 0, 0.5)",
                                   backdropFilter: "blur(5px)",
                                   zIndex: 999,
                                 }}
                                 onClick={() => setSelectedGR(null)}
                               ></div>
                               <div
                                 style={{
                                   position: "fixed",
                                   top: "50%",
                                   left: "50%",
                                   transform: "translate(-50%, -50%)",
                                   backgroundColor: "white",
                                   padding: "20px",
                                   borderRadius: "10px",
                                   boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
                                   zIndex: 1000,
                                 }}
                               >
                                 <h2 style={{ marginBottom: "15px" }}>
                                   {t("GR Details")}: {selectedGR.GRID}
                                 </h2>
                                 <div
                                   style={{
                                     display: "grid",
                                     gridTemplateColumns: "1fr 1fr",
                                     gap: "10px",
                                   }}
                                 >
                                   {Object.entries(selectedGR).map(([key, value]) => (
                                     <div key={key}>
                                       <strong>{key}:</strong>{" "}
                                       {key.toLowerCase().includes("copy") && value ? (
                                         <a
                                           href={`${apiurl}/ProjectDocsImages/${value}`}
                                           target="_blank"
                                           rel="noreferrer"
                                           style={{ color: "blue" }}
                                         >
                                           {t("View Document")}
                                         </a>
                                       ) : (
                                         <span>{String(value)}</span>
                                       )}
                                     </div>
                                   ))}
                                 </div>
           
                                 <button
                                   onClick={() => setSelectedGR(null)}
                                   style={{
                                     marginTop: "20px",
                                     padding: "10px 20px",
                                     backgroundColor: "#f44336",
                                     color: "white",
                                     border: "none",
                                     borderRadius: "5px",
                                     cursor: "pointer",
                                   }}
                                 >
                                   {t("Close")}
                                 </button>
                               </div>
                             </>
                           )}
           
                           {/* Pagination Controls */}
                           <div
                             className="my-4 d-flex justify-content-between align-items-center"
                             style={{ flexWrap: "wrap" }}
                           >
                             <p
                               className="text-gray-600"
                               style={{ fontSize: "18px", margin: 0 }}
                             >
                               {t("Showing")}{" "}
                               {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                               {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                               {t("of")} {filteredBills?.length} {t("entries")}
                             </p>
           
                             <div
                               className="col-6"
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "end",
                               }}
                             >
                               <GooglePagination
                                 currentPage={currentPage}
                                 totalPages={totalPages}
                                 onPageChange={setCurrentPage}
                               />
                             </div>
                           </div>
                           <div
                             className="col-6 text-start mt-3"
                             style={{ display: "flex", justifyContent: "left" }}
                           >
                             <button
                               onClick={() => approveorrejectSelected("Approved")}
                               //    onClick={(e) => { SetGenerateToken(false) }}
                               disabled={selectedBills.length <= 0 ? true : loading}
                               className="ms-0"
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 gap: "0.3rem",
                                 margin: "12px",
                                 padding: "8px 10px",
                                 fontWeight: "600",
                                 backgroundColor:
                                   selectedBills.length <= 0
                                     ? "rgba(141, 141, 141, 0.97)"
                                     : "#39B54A",
                                 color: "white",
                                 borderRadius: "8px",
                                 cursor:
                                   selectedBills.length <= 0
                                     ? "not-allowed"
                                     : loading
                                       ? "not-allowed"
                                       : "pointer",
                               }}
                             >
                               <img
                                 src="/Approve-Selected32.png"
                                 style={{
                                   width: "1rem",
                                   height: "1rem",
                                   filter: "brightness(0) invert(1)",
                                 }}
                               />{" "}
                               {loading ? t("Processing...") : t("Approve Selected")}
                             </button>
           
                             <button
                               onClick={() => setRejectpanelhide(2)}
                               // onClick={(e) => { SetGenerateRejectToken(false) }}
                               disabled={selectedBills.length <= 0 ? true : loading}
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 gap: "0.3rem",
                                 margin: "12px",
                                 padding: "8px 10px",
                                 fontWeight: "600",
                                 background:
                                   selectedBills.length <= 0
                                     ? "rgba(141, 141, 141, 0.97)"
                                     : "#C1272D",
                                 color: "white",
                                 borderRadius: "8px",
                                 cursor:
                                   selectedBills.length <= 0
                                     ? "not-allowed"
                                     : loading
                                       ? "not-allowed"
                                       : "pointer",
                               }}
                             >
                               <img
                                 src="/Reject-Selected32.png"
                                 style={{
                                   width: "1rem",
                                   height: "1rem",
                                   filter: "brightness(0) invert(1)",
                                 }}
                               />{" "}
                               {loading ? t("Processing...") : t("Reject Selected")}
                             </button>
           
                             {adminData.Role !== "RDD Section Officer" && (
                               <button
                                 onClick={() => setRejectpanelhide(3)}
                                 disabled={selectedBills.length <= 0 ? true : loading}
                                 style={{
                                   display: "flex",
                                   alignItems: "center",
                                   gap: "3px",
                                   margin: "12px",
                                   padding: "8px 10px",
                                   fontWeight: "600",
                                   background:
                                     selectedBills.length <= 0
                                       ? "rgba(141, 141, 141, 0.97)"
                                       : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                   color: "white",
                                   borderRadius: "8px",
                                   cursor:
                                     selectedBills.length <= 0
                                       ? "not-allowed"
                                       : loading
                                         ? "not-allowed"
                                         : "pointer",
                                 }}
                               >
                                 <img
                                   src="/Send-Back-Selected32.png"
                                   style={{
                                     width: "1rem",
                                     height: "1rem",
                                     filter: "brightness(0) invert(1)",
                                   }}
                                 />{" "}
                                 {loading ? t("Processing...") : t("Send Back Selected")}
                               </button>
                             )}
                           </div>
                         </div>
                       </div>
          </div>
        </div>
      </div>

      {rejectPanelhide === 2 && (
        <div className="col-12 RejectPanelContainer" 
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
          }}>
          <div className="Rejectpanel">
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className="fw-bold">
                      {t("Remark")} <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-8">
                    <textarea
                      name=""
                      id=""
                      placeholder={t("Enter Remark")}
                      value={remark}
                      onChange={(e) =>
                        setRemark(e.target.value.replace(/^\s+/, ""))
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                <div className="col-9 m-auto">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        width: "5rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => approveorrejectSelected("Rejected")}
                    >
                      <img src={submit} style={{ width: "15px" }} /> Reject
                    </button>
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        backgroundColor: "#f1594c",
                        width: "6rem",
                        height: "2rem",
                        fontSize: "16px",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {" "}
                      <img src={Cancel32} style={{ width: "17px" }} />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {rejectPanelhide === 3 && (
        <div className="col-12 RejectPanelContainer"
          style={{
            
            zIndex: 9999,
          }}>
          <div className="Rejectpanel">
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className="fw-bold">
                      {t("Remark")} <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-8">
                    <textarea
                      name=""
                      id=""
                      placeholder={t("Enter Remark")}
                      value={remark}
                      onChange={(e) =>
                        setRemark(e.target.value.replace(/^\s+/, ""))
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        width: "8rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => approveorrejectSelected("SendBack")}
                    >
                      <img src={submit} style={{ width: "15px" }} />
                      {t("Send Back")}
                    </button>
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        backgroundColor: "#f1594c",
                        width: "6rem",
                        height: "2rem",
                        fontSize: "16px",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {" "}
                      <img src={Cancel32} style={{ width: "17px" }} />
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div
          style={{
            position: "fixed",
            padding: "10rem",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          hidden={GenerateToken}
        >
          <div
            class="card-body"
            style={{ backgroundColor: "white", width: "50%" }}
          >
            <h6>{t("Send Message")}</h6>
            <div class="card form-control" style={{ width: "100%" }}>
              <div class="card-body">
                <h5 class="card-title">{t("Generate Token")}</h5>
                <textarea
                  class="form-control"
                  id="tokencopys"
                  value={Etoken}
                ></textarea>
                <button
                  hidden={Etoken}
                  className="btn btn-success mx-2"
                  style={{
                    backgroundColor: "rgb(10, 200, 150)",
                    border: "none",
                    borderRadius: "10px",
                  }}
                  onClick={GenerateTokenFor}
                >
                  {t("Generate Token")}
                </button>
              </div>
            </div>
            <button
              onClick={() => approveorrejectSelected("Approved")}
              hidden={hide}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                margin: "12px",
                padding: "8px 15px",
                background:
                  "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                color: "white",
                borderRadius: "5px",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              <img
                style={{ width: "14px", filter: "brightness(0) invert(1)" }}
              />{" "}
              {loading ? t("Processing...") : t("Approve Selected")}
            </button>
            {/* <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button> */}
            <button
              className="btn btn-danger"
              onClick={(x) => {
                SetGenerateToken(true);
                SetEtoken("");
              }}
            >
              {t("close")}
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div
          style={{
            position: "fixed",
            padding: "10rem",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          hidden={GenerateRejectToken}
        >
          <div class="card-body" style={{ backgroundColor: "white" }}>
            <h6>{t("Send Message")}</h6>
            <div class="card form-control" style={{ width: "100%" }}>
              <div class="card-body">
                <h5 class="card-title">{t("Generate Token")}</h5>
                <textarea
                  class="form-control"
                  id="tokencopys"
                  value={Etoken}
                ></textarea>
                <button
                  hidden={Etoken}
                  className="btn btn-success mx-2"
                  style={{
                    backgroundColor: "rgb(10, 200, 150)",
                    border: "none",
                    borderRadius: "10px",
                  }}
                  onClick={GenerateTokenFor}
                >
                  {t("Generate Token")}
                </button>
              </div>
            </div>
            <div className="form-group my-3">
              <label htmlFor="remark">
                {t("Remark (Required for Rejection):")}
              </label>
              <textarea
                className="form-control"
                name=""
                id=""
                placeholder={t("Enter Remark")}
                value={remark}
                onChange={(e) => setRemark(e.target.value.replace(/^\s+/, ""))}
              ></textarea>
            </div>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                background:
                  "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                width: "5rem",
                height: "2rem",
                fontSize: "18px",
              }}
              onClick={() => approveorrejectSelected("Rejected")}
              hidden={hide}
            >
              <img src={submit} style={{ width: "15px" }} /> {t("Reject")}
            </button>
            {/* <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button> */}
            <button
              className="btn btn-danger"
              onClick={(x) => {
                SetGenerateRejectToken(true);
                SetEtoken("");
              }}
            >
              {t("close")}
            </button>
          </div>
        </div>
      </div>
 </>
        )}

  {
        showWorksView && (
          <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll", position: "relative" }}>
            <div style={{ filter: loading ? "blur(4px)" : "none", pointerEvents: loading ? "none" : "auto", transition: "0.2s ease" }}>
              <div className="col-11 m-auto">
                <div className="col-12 ">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      padding: "10px 4rem",
                    }}
                  >
                    <button className='btn btn-danger px-3 py-1' onClick={() => { setShowWorksView (false); setWorksData([]); }}>{t("Back")}</button>
                    <h5 className='my-auto fw-bold'>
                      <img src="/Work-Order-Outwards-Blue64.png" alt="Works" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                      <span className='my-auto '>{t("Works under GR")} {grId}</span>
                    </h5>
                    
                  </div>

                  <div className="col-12 pb-5">
                    <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "30px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%" }}>
                      <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'auto' }}>
                      <table
                        className="m-0 p-0"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th style={{ padding: "8px" }}>{t("Sr.No.")}</th>
                            <th style={{ minWidth: "150px", padding: "8px" }}>
                              {t("Work Name")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("Job ID")}
                            </th>
                            <th style={{ minWidth: "120px", padding: "8px" }}>
                              {t("Class of Work")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("GR Date")}
                            </th>
                              <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("GR Amount")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("Work Unique ID")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("GR Copy")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("Remark")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {worksData?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="8"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No works found for this GR")}
                              </td>
                            </tr>
                          ) : (
             worksData.map((work, index) => (
                              <tr
                               key={work.JOB_ID ?? index}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                  fontSize: "18px",
                                }}
                              >
                                <td style={{ padding: "8px" }}>{index + 1}</td>
                                <td style={{ padding: "8px" }}>
                                  {work.Work_name}
                                </td>
                                <td style={{ padding: "8px" }}>
                                  {work.JOB_ID}
                                </td>
                                <td style={{ padding: "8px" }}>
                                  {work.classOfWork}
                                </td>
                                 <td style={{ padding: "8px" }}>
              {work.GRDate && !isNaN(new Date(work.GRDate).getTime())
                  ? new Date(work.GRDate).toLocaleDateString("en-IN")
                  : "-"}
                    </td>
      
                              <td style={{ padding: "8px" }}>
                                                        {work.ProposalAmount}
                                                      </td>
                                <td style={{ padding: "8px" }}>
                                  {work.workuniqueid}
                                </td>
                                 <td style={{ padding: '8px' }}>
                                {work.GRUploadFile || work.GRCopy ? (
                                  <>
                                    {work.GRUploadFile && (
                                      <div>
                                        <a
                                          href={`${apiurl}/ProposalFile/${work.GRUploadFile}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {work.GRUploadFile}
                                        </a>
                                      </div>
                                    )}

                                    {work.GRCopy && (
                                      <div>
                                        <a
                                          href={`${apiurl}/ProjectDocsImages/${work.GRCopy}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {work.GRCopy}
                                        </a>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <p className="text-danger my-auto fw-bold">
                                    {t("No File")}
                                  </p>
                                )}
                              </td>
                                <td style={{ padding: "8px" }}>
                                  {work.workRemark}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export default GRApprovals;
